import { COMPANY } from "@/data/content";
import Logo from "@/components/site/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-white/10 bg-[#050505]"
      data-testid="footer"
    >
      {/* Giant wordmark */}
      <div className="overflow-hidden border-b border-white/10 px-5 py-12 md:px-10 md:py-16">
        <div className="font-display text-[13vw] font-extrabold uppercase leading-[0.8] tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.14)]">
          Yamunesh
        </div>
      </div>

      <div className="mx-auto flex max-w-[1600px] flex-col items-start justify-between gap-6 px-5 py-8 md:flex-row md:items-center md:px-10">
        <div className="flex items-center gap-3">
          <Logo size={22} className="text-white shrink-0" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#a1a1aa]">
            {COMPANY.name}
          </span>
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525b]">
          © {year} — All rights reserved · Mumbai, IN
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525b]">
          webMethods · Boomi · Enterprise Integration
        </div>
      </div>
    </footer>
  );
}
